// Nomad-mon Go! v237 — CAMPAIGN XP: the hook the campaign engine calls after every campaign match.
//
//   import { campaignReward } from './campaign-xp.js';
//   const r = await campaignReward(levelId, { stars, cards, enemyPower });
//
// levelId: the slot 'w<world>-<level>' (1-based, 15 x 15). A record whose stable id is not a slot
// passes { world, index } too. stars: 0 for a loss, else 1..3. cards: the five that fought (card
// XP); enemyPower: as for reportRecord (victoryXp). `firstClear` may be passed but is advisory only:
// the ledger (server for named players, local for guests / offline) decides what is a first.
//
// Rules (src/plevel.js PLEVEL.campaign, campaignXp; tuned by scripts/plevel-sim.mjs --campaign):
//   * player XP ONLY for a level's first clear, each star the first time it is earned, the mini-boss
//     (slot 8) and world-boss (slot 15) first clears, and the world clear (= first clear of slot 15);
//     a loss pays 0, a replay pays 0 unless it earns a star not earned before;
//   * the daily first-win + mission terms count campaign wins (once per UTC day each);
//   * card XP on the first clear, else only on the first replay of that level per UTC day;
//   * no rested bonus, no wins/losses/streak/pack changes (those stay with Quick Match / the reward table).
// Campaign matches must NOT also go through identity.reportRecord (that pays Quick Match XP).
//
// Returns { slot, prevStars, stars (best), firstClear, newStars, cardXp, progress (card rows, like
// reportRecord), plevel: { beforeXp, xp, gained, parts } | null, paid } — or { error } for a bad slot.
import { campaignSlot, parseCampaignSlot, campaignXp, PLEVEL } from './plevel.js';
import * as identity from './identity.js';

export function slotOf(levelId, { world, index } = {}) {
  return (world != null && index != null) ? campaignSlot(world, index) : parseCampaignSlot(levelId);
}

export async function campaignReward(levelId, opts = {}) {
  const slot = slotOf(levelId, opts);
  if (!slot) return { error: 'BAD_LEVEL', slot: null, paid: false, cardXp: false, progress: [], plevel: null };
  return identity.reportCampaign(slot, opts);
}

/** { 'w<W>-<L>': best stars } — the higher of server and local. */
export function campaignProgress() { return identity.campaignProgress(); }
/** Push local-only stars to the server (records, never pays). Call after sign-in / coming online. */
export function syncCampaign() { return identity.syncCampaign(); }

/** What a level still has to give (level card / results preview): first clear + the stars not yet earned. */
export function campaignXpLeft(levelId, opts = {}) {
  const slot = slotOf(levelId, opts);
  if (!slot) return 0;
  const prev = campaignProgress()[slot.id] || 0;
  return campaignXp({ world: slot.world, index: slot.index, prevStars: prev, stars: 3 }).total;
}

export const CAMPAIGN_XP = PLEVEL.campaign;
